import React from "react";
import "./PromoLayout.scss"
import history from "../../../assets/history.svg"
import arrowWhite from "../../../assets/arrow-right-black.svg"
import clock from "../../../assets/clock.svg"
import { getCurrencyFormat, LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../../utilities/helper";
import { useDispatch, useSelector } from "react-redux";
import IMAGE_PLACEHOLDER from "../../../assets/images/Images/empty-placeholder.png"
import { setSelectedOffer } from "../../../../../../../../redux/companyDataSlice";

const PromoSingleLayout = ({ promos }) => {
    const selectedOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const { currency
    } = useSelector((state) => state.resturantData);
    const currencyFormat = getCurrencyFormat(currency);
    const dispatch = useDispatch()
    const getThePrice = (price) => {
        let priceValue;

        switch (selectedOrderType) {
            case "delivery":
                priceValue = price?.DeliveryPrice;
                break;
            case "table":
                priceValue = price?.TablePrice;
                break;
            default:
                priceValue = price?.PickupPrice;
                break;
        }
        return currencyFormat(priceValue / 100);
    };
    return (
        <div className="PromoLayout">
            <div className="PromoLayoutStyles">
                {promos.map((promo, key) => {
                    return (
                        <div className="PromoLayout" key={key}>
                            <div className="header-contne-cont">
                                <div className="header-prom">
                                    <div className="prom-cont-so" style={{ background: '#FEF3C7' }}>
                                        <img alt='' src={clock} className='icon' />
                                        <div className="prom-btn" style={{ color: "#D97706" }}>Limited Time</div>
                                    </div>
                                    <div className="prom-header">{promo?.Title?.en}</div>
                                    <div className="prom-sub">{promo?.Description?.en}</div>
                                    <div className="save-content-container">        <div className="save-price-cont">
                                        <div className="new-am">{getThePrice(promo?.PriceInfo?.Price)}
                                        </div>
                                    </div></div>
                                    {/* {promo.isSave && <div className="save-content-container">
                                        <div className="save-price-cont"><div className="old-am">{promo.amount}</div>
                                            <div className="new-am">{promo.newAmount}</div>

                                        </div>

                                        <div className="code-con"><div className="code-re">Use code:</div>
                                            <div className="code-txt">{promo.code}</div>
                                        </div></div>} */}
                                    <div className="bottom-contne-cont">
                                        <div className="prom-bot">
                                            <img alt='' src={history} className='icon' />
                                            Limited time offer</div>
                                        <div className="prom-btn"
                                            onClick={() => {
                                                dispatch(setSelectedOffer(promo.MenuItemID + "/new"))
                                            }}>Order Now
                                            <img alt='' src={arrowWhite} className='icon' />

                                        </div>

                                    </div>

                                </div>
                                <div className="promo-iamge">
                                    <img alt="" src={promo?.ImageURL ? promo?.ImageURL : IMAGE_PLACEHOLDER} />
                                    <div className="img-overlay" />
                                </div>
                            </div>

                        </div>
                    )
                })}
            </div>
        </div>

    )
}
export default PromoSingleLayout